import { Flex, Text } from "@chakra-ui/react";
import moment from "moment";
import { useTranslation } from "react-i18next";
import type { AgentConversationSummaryDto } from "../../autogen/bff-api";
import { momentLocaleFor } from "../formatting/i18nFormatters";
import { presentName, useUntitledName } from "./useEntityTitle";

export const ConversationRowDetail = ({ conversation }: { conversation: AgentConversationSummaryDto }) => {
  const { i18n } = useTranslation();
  const untitledName = useUntitledName();
  const { procurement } = conversation;
  return (
    <Flex fontSize="xs" color="smTextDisabled" minW="0" data-testid="conversation-row-detail">
      {procurement && (
        <>
          <Text as="span" minW="0" isTruncated>
            {presentName(procurement.title) ?? untitledName("v2Event")}
          </Text>
          <Text as="span" flexShrink={0} whiteSpace="pre">
            {" · "}
          </Text>
        </>
      )}
      <Text as="span" flexShrink={0} whiteSpace="nowrap">
        {moment(conversation.modifiedAt).locale(momentLocaleFor(i18n.language)).fromNow()}
      </Text>
    </Flex>
  );
};
